import { Component, OnDestroy, OnInit } from '@angular/core';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import {
  ScreenOrientation,
} from '@capacitor/screen-orientation';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  constructor() {
    // This is needed to utilize the camera on computer
    defineCustomElements(window);
    ScreenOrientation.lock({ orientation: 'portrait' });
  }
  ngOnInit(): void {
    // this.socketService.setupSocketConnection();
  }
  ngOnDestroy() {
    // this.socketService.disconnect();
  }
}
